import { GDTApiErrors } from '@/types';
import {
  ResponseRankingHistoric,
  ResponseCurrentTeam,
  ResponseChangeTeam,
  RequestChangeTeam,
  TacticAssistant,
} from '@/types/team';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

const headers = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

export const getDataRanking = axiosErrorHandler(async (date: string) => {
  const url = `${URLs.EQUIPO_11.RANKING}&fecha=${encodeURIComponent(date)}`;
  const response = await axiosGdt.post<ResponseRankingHistoric>(url);
  return response.data;
}, TEXTS.defaultError);

export const getCurrentTeamF11 = axiosErrorHandler(async () => {
  const url = URLs.EQUIPO_11.EQUIPO_ACTUAL;
  const response = await axiosGdt.get<ResponseCurrentTeam | GDTApiErrors>(url);

  return response.data;
}, TEXTS.defaultError);

export const postChangeTeam = axiosErrorHandler(
  async (dataChange: RequestChangeTeam) => {
    const url = URLs.EQUIPO_11.HACER_CAMBIO;
    const response = await axiosGdt.post<ResponseChangeTeam>(
      url,
      dataChange,
      headers
    );
    return response.data;
  },
  TEXTS.defaultError
);

// F_424 -> 8
// F_433 -> 2
// F_442 -> 1
// F_451 -> 4
// F_334 -> 7
// F_343 -> 3
// F_352 -> 5
// F_523 -> 9
// F_532 -> 6
export const getTacticAssistant = axiosErrorHandler(
  async (currentTatic: number) => {
    const url = URLs.EQUIPO_11.AYUDANTE_DE_TACTICA;
    const response = await axiosGdt.get<TacticAssistant>(
      `${url}&origen=${currentTatic}`
    );

    return response.data;
  },
  TEXTS.defaultError
);
